import { UPDATE_LOCATION_FOR_SHARED_ROOM } from '../constants/action-types';
export const updateLocationForSharedRoom = ({ roomId, locationId }) => ({
    type: UPDATE_LOCATION_FOR_SHARED_ROOM,
    payload: {
        roomId,
        locationId,
    },
});
